// This file is automatically generated. Do not edit manually.

import { CargoDriver } from "src/api/generated/erp/db/types/tables/cargoDriver";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CargoDriversApi {
	export async function getAll(): Promise<Array<CargoDriver>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/warehouse/basedata/cargoDriversDataGrid/getAll",
			method: "POST",
			data: {},
		});
		return response as Array<CargoDriver>;
	}

	export async function save(args: {
		cargoDrivers: Array<CargoDriver>;
	}): Promise<Array<CargoDriver>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/warehouse/basedata/cargoDriversDataGrid/save",
			method: "POST",
			data: {
				cargoDrivers: args.cargoDrivers,
			},
		});
		return response as Array<CargoDriver>;
	}

	export async function delete_(args: { cargoDrivers: Array<CargoDriver> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/warehouse/basedata/cargoDriversDataGrid/delete",
			method: "POST",
			data: {
				cargoDrivers: args.cargoDrivers,
			},
		});
		return response as void;
	}
}
